var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParkingCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1223 16.9843V28.0786C30.1223 29.304 29.6355 30.4792 28.769 31.3457C27.9025 32.2122 26.7273 32.699 25.5019 32.699H6.35826C5.75125 32.6994 5.15011 32.5802 4.58919 32.3481C4.02827 32.1161 3.51857 31.7758 3.08921 31.3468C2.65985 30.9177 2.31924 30.4082 2.08686 29.8474C1.85447 29.2867 1.73486 28.6856 1.73486 28.0786V8.93492C1.73447 8.32765 1.85378 7.72627 2.08599 7.16515C2.3182 6.60403 2.65874 6.0942 3.08814 5.6648C3.51754 5.2354 4.02737 4.89486 4.58849 4.66265C5.14961 4.43044 5.75099 4.31113 6.35826 4.31152H19.663",
    stroke: "#231F20",
    strokeWidth: 1.54,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4234 15.1262C32.6004 15.1262 35.9865 11.7401 35.9865 7.56309C35.9865 3.38611 32.6004 0 28.4234 0C24.2465 0 20.8604 3.38611 20.8604 7.56309C20.8604 11.7401 24.2465 15.1262 28.4234 15.1262Z",
    fill: "#106C47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8553 2.3833C28.1226 2.3833 28.3396 2.59949 28.3397 2.8667V8.40674C28.3396 8.67396 28.1226 8.89014 27.8553 8.89014C27.5882 8.89001 27.3721 8.67389 27.3719 8.40674V2.8667C27.3721 2.59957 27.5882 2.38343 27.8553 2.3833Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9992 10.1922C31.8936 10.4377 31.6093 10.5517 31.3638 10.4462L27.7026 8.87174C27.457 8.76613 27.3434 8.48098 27.449 8.23541C27.5547 7.98998 27.8395 7.87712 28.085 7.98269L31.7461 9.55717C31.9915 9.66282 32.1046 9.94676 31.9992 10.1922Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9406 12.1665V12.1675C17.6236 12.1553 18.3023 12.2779 18.9366 12.5317C19.5746 12.7871 20.1549 13.1687 20.6427 13.6528H20.6417C21.1312 14.1244 21.5187 14.6917 21.7784 15.3198C22.036 15.9428 22.1626 16.6119 22.1515 17.2856L22.1505 17.5415C22.1324 18.1375 22.0057 18.7264 21.7775 19.2788C21.5177 19.9074 21.1302 20.4746 20.6407 20.9468L20.6417 20.9478C20.1536 21.4308 19.5734 21.8111 18.9357 22.0659C18.3015 22.3193 17.6232 22.4423 16.9406 22.4302V22.4312H15.1681V26.2085L15.1554 26.3374C15.13 26.4645 15.0677 26.5823 14.9747 26.6753C14.8507 26.7993 14.6824 26.8696 14.507 26.8696H11.9669C11.7915 26.8696 11.6232 26.7993 11.4991 26.6753C11.3753 26.5514 11.3059 26.3836 11.3058 26.2085V12.8276C11.3058 12.6522 11.3751 12.4839 11.4991 12.3599L11.5997 12.2769C11.7076 12.205 11.8354 12.1665 11.9669 12.1665H16.9406ZM15.1681 18.7427H16.9406C17.7203 18.7427 18.3077 18.1511 18.3077 17.2983C18.3076 16.4458 17.7202 15.854 16.9406 15.854H15.1681V18.7427Z",
    stroke: "#231F20",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingCloseIcon);
export default __webpack_public_path__ + "static/media/parkingCloseIcon.aebe8418cf389aadecf0a33934586e3e.svg";
export { ForwardRef as ReactComponent };